import { Link } from "react-router-dom";
import { ArrowUpRight, BookOpen, Clock } from "lucide-react";
import SEO from "@/components/SEO";
import { guides } from "@/data/guides";
import CTASection from "@/components/sections/CTASection";

export default function GuideIA() {
  return (
    <>
      <SEO
        title="Guide IA — Comprendre l'intelligence artificielle"
        description="Guide IA par YAFORMIS : comprendre l'intelligence artificielle, ses usages, ses limites, ses biais et ses enjeux. Articles éditoriaux pour décideurs et curieux."
        path="/guide-ia"
      />

      <section className="bg-brand-page py-12 md:pt-16 pb-10 md:pb-14 border-b border-brand-line" data-testid="guide-hero">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <div className="overline">Guide IA</div>
          <h1 className="font-heading font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-3 leading-[1.05] text-brand-ink max-w-4xl">
            Comprendre l'intelligence artificielle, sans jargon.
          </h1>
          <p className="mt-5 text-lg text-slate-600 max-w-3xl leading-relaxed">
            Cinq articles pour saisir l'essentiel : ce qu'est vraiment l'IA, ses usages, ses limites, ses biais et les questions qu'elle pose à notre société.
          </p>
        </div>
      </section>

      <section className="bg-brand-surface py-14 md:py-20" data-testid="guide-list">
        <div className="max-w-5xl mx-auto px-5 md:px-8">
          <ul className="divide-y divide-brand-line border-y border-brand-line bg-white">
            {guides.map((g, i) => (
              <li key={g.slug}>
                <Link
                  to={`/guide-ia/${g.slug}`}
                  data-testid={`guide-card-${g.slug}`}
                  className="group grid grid-cols-12 gap-4 md:gap-8 items-start md:items-center px-5 md:px-8 py-7 md:py-9 hover:bg-brand-surface transition-colors"
                >
                  <div className="col-span-12 md:col-span-1 num-marker pt-1">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="col-span-12 md:col-span-9">
                    <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-blue mb-2">
                      {g.category} · {g.readingTime}
                    </div>
                    <h2 className="font-heading font-bold text-xl sm:text-2xl md:text-3xl leading-snug tracking-tight text-brand-ink group-hover:text-brand-blue transition-colors">
                      {g.title}
                    </h2>
                    <p className="mt-3 text-slate-600 leading-relaxed text-[15px] md:text-base">
                      {g.excerpt}
                    </p>
                  </div>
                  <div className="col-span-12 md:col-span-2 flex md:justify-end">
                    <span className="inline-flex items-center gap-2 text-sm font-semibold text-brand-ink group-hover:text-brand-blue group-hover:gap-3 transition-all">
                      Lire <ArrowUpRight className="w-4 h-4" />
                    </span>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <CTASection />
    </>
  );
}
